import React from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { useGetSalesIds } from '../../api/sales'

export const SalesFilter = ({ setSalesId, salesId, htgCompany = '' }) => {
  const { data = [], isLoading } = useGetSalesIds({ htgCompany })

  return (
    <Autocomplete
      options={data}
      sx={{ maxWidth: 250 }}
      onChange={(event, value) => setSalesId(value)}
      size='small'
      fullWidth
      renderInput={(params) => <TextField {...params} label='Sales Id' />}
      value={salesId || null}
      disabled={isLoading}
      loading={isLoading}
    />
  )
}
